// Traduction des chaînes qui n'ont pas (encore) de clé sémantique.
//
// Principe : une chaîne française littérale dans le JSX est traduite via
// `ht("...")`, qui lookup la clé `hard.<slug>` dans les locales.
//
//   <th>Code</th>            →  <th>{ht("Code")}</th>
//   title="Supprimer"       →  title={ht("Supprimer")}
//
// Pourquoi : les clés sémantiques (dashboard.title, users.title…) restent
// la source de vérité pour les textes récurrents ; `ht()` couvre les
// libellés ponctuels (colonnes de tableau, boutons, toasts) sans avoir à
// créer 300 clés numérotées.
//
// ⚠️ Le re-render au changement de locale est déclenché par `useT()` :
//    chaque composant appelant `ht()` doit aussi appeler `useT()` (ou être
//    un descendant d'un composant qui le fait) pour être re-rendu.
import { t } from "@/lib/i18n";

/** Normalise une phrase FR en slug de clé : "N° châssis" → "n_chassis". */
export function hardKey(fr: string): string {
  return (
    fr
      .normalize("NFD")
      // supprime les diacritiques
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .slice(0, 60) || "text"
  );
}

/**
 * Traduit une chaîne française littérale.
 * Retourne la chaîne d'origine si aucune traduction n'existe.
 */
export function ht(fr: string): string {
  const translated = t(`hard.${hardKey(fr)}`);
  // Si la clé n'existe pas, `t()` retourne la clé elle-même → on retombe
  // sur le texte FR d'origine.
  return translated.startsWith("hard.") ? fr : translated;
}
